import { Stack, StackProps, styledPolymorphic } from '@qred/components-library';

export const CheckpointPage = styledPolymorphic<'div', {}>()((_styled) =>
  _styled(() => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'auto',
  }))
);

export const CheckpointContent = styledPolymorphic<'div', {}>()((_styled) =>
  _styled(({ theme }) => ({
    width: '968px',
    maxWidth: '100%',
    display: 'grid',
    gridTemplateRows: 'auto auto auto auto',
    justifySelf: 'center',
    position: 'relative',
    maxHeight: '100%',
    height: '100%',
    gridTemplateColumns: '16px 1fr 1fr 16px',
    overflowX: 'clip',

    [theme.fn.largerThan('tablet')]: {
      overflow: 'unset',
      height: 'unset',
      gridTemplateColumns: '1fr 284px 284px 1fr',
    },

    '> :first-child': {
      gridColumn: '2',
      gridRow: '2',
      marginBottom: '16px',
      [theme.fn.largerThan('tablet')]: {
        marginBottom: '24px',
        maxHeight: 'fit-content',
        height: '360px',
      },
    },
    '> :nth-child(2)': {
      gridColumnStart: '3',
      gridColumnEnd: '3',
      gridRowStart: '1',
      gridRowEnd: '3',
      position: 'absolute',
      bottom: '-50px',
      right: '-150px',
      height: '100%',
      [theme.fn.largerThan('tablet')]: {
        top: 0,
        right: '-100px',
        height: '360px',
      },
    },

    '> :nth-child(3)': {
      gridColumnStart: '3',
      gridColumnEnd: '3',
      gridRowStart: '1',
      gridRowEnd: '3',
      position: 'absolute',
      bottom: '-50px',
      right: '-100px',
      height: '100%',
      [theme.fn.largerThan('tablet')]: {
        top: 0,
        right: '0',
        height: '360px',
      },
    },

    '> :nth-child(4)': {
      gridColumnStart: '2',
      gridColumnEnd: '4',
      gridRow: '3',
    },

    '> :nth-child(5)': {
      gridColumnStart: '2',
      gridColumnEnd: '4',
      gridRow: '4',
      padding: '16px 0',
      alignSelf: 'end',
      [theme.fn.largerThan('tablet')]: {
        alignSelf: 'unset',
      },
    },
  }))
);

export const AnimatedWrapper = styledPolymorphic<'div', StackProps>(Stack)(
  (_styled) =>
    _styled(() => ({
      zIndex: 2,
      justifyContent: 'end',
      '@keyframes slideUp': {
        from: {
          transform: 'translateY(100%)',
          opacity: 0,
        },
        to: {
          transform: 'translateY(0)',
          opacity: 1,
        },
      },
      animation: 'slideUp 0.5s ease-out 0.5s forwards',
      transform: 'translateY(100%)',
      opacity: 0,

      button: {
        textAlign: 'left' as const,
      },
    }))
);

export const ContentCard = styledPolymorphic<'div'>()((_styled) =>
  _styled(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column' as const,
    padding: '16px',
    zIndex: 3,
    borderRadius: '8px',
    background: theme.fn.themeColor('Container/Option_2_(White)'),
    height: 'fit-content',

    [theme.fn.largerThan('tablet')]: {
      padding: '32px 24px',
    },
  }))
);

export const LoadingAnimation = styledPolymorphic<'img'>()((_styled) =>
  _styled(() => ({
    width: '160px',
    height: '160px',
    alignSelf: 'center',
    margin: '50px',
  }))
);
